module.exports = __webpack_public_path__ + "static/Zeugnisprozess_Release_3_8_12-fc98e6120172341a4a18faa438b0a2ca.pdf";